<template>
  <component
    :is="disableLink ? 'div' : 'router-link'"
    :to="user.managerUrl()"
  >
    <profile-picture
      v-if="pictureLeft"
      :user="user"
      :width="pictureWidth"
      class="mr-2"
    />
    <span
      class="text-sm-h6 text-subtitle-2 font-weight-bold vertical-align-middle"
    >
      {{ user.nickname }}
    </span>
    <profile-picture
      v-if="!pictureLeft"
      :user="user"
      :width="pictureWidth"
      class="ml-2"
    />
  </component>
</template>

<script>
import ProfilePicture from '@/components/User/ProfilePicture.vue';
import User from '@/models/User/user';

export default {
  name: 'UserNicknamePicture',
  components: {
    ProfilePicture,
  },
  props: {
    user: {
      type: User,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    pictureLeft: {
      type: Boolean,
      default: false,
    },
    disableLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pictureWidth() {
      if (this.small && this.$vuetify.display.xs) {
        return '30px';
      }

      return '50px';
    },
  },
};
</script>
